import React from "react";

// Test mode (Customer.testMode, set by an admin): the booking or payment uses the Razorpay TEST account, so no real
// money moves, and it is left out of the dashboards and money totals (see the Test view of the dashboard).
export const isTest = (mode) => mode === "test";

// The small "TEST" tag next to an id or a name. Text, not colour alone.
const TestModeTag = ({ mode, className = "ms-2" }) => (isTest(mode)
    ? <span className={`badge bg-warning text-dark ${className}`} title="Test mode: Razorpay test account, no real money">TEST</span>
    : null);

// The note at the top of a test booking or customer.
export const TestModeBanner = ({ mode, what = "booking" }) => (isTest(mode) ? (
    <div className="alert alert-warning d-flex align-items-center gap-2 py-2" role="note">
        <span className="badge bg-dark">TEST</span>
        <span>
            {what === "customer"
                ? "Test mode is on: this customer's new bookings are paid with the Razorpay test account (no real money). They are left out of the dashboards and totals."
                : "Test booking: paid with the Razorpay test account, no real money moves. It is left out of the dashboards and money totals."}
        </span>
    </div>
) : null);

export default TestModeTag;
